import { Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentPlansComponent } from './payment-plans.component';
import { TooltipModule } from 'primeng/tooltip';
import { ReactiveFormsModule } from '@angular/forms';
import { createCustomElement } from '@angular/elements';
import { FormUtilitiesModule } from '../../ds24-ui/form-utilities';

@NgModule({
  declarations: [PaymentPlansComponent],
  imports: [
    CommonModule,
    TooltipModule,
    ReactiveFormsModule,
    FormUtilitiesModule,
  ],
})
export class PaymentPlansModule {
  static initialize(injector: Injector) {
    const customComponent = createCustomElement(PaymentPlansComponent, {
      injector: injector,
    });
    customElements.define('ds-orderform-payment-plans', customComponent);
  }
}
